module.exports = __webpack_public_path__ + "static/media/pic7.1332b288.jpg";